export default "__VITE_ASSET__Cn9MpP5T__"